document.addEventListener("DOMContentLoaded", function () {
  initializeSwiper();
});

function initializeSwiper() {
  new Swiper(".swiper", {

    loop: true,
    slidesPerView: 1.15,
    breakpoints: {
      640: {
        slidesPerView: 1.8,
      },
      1024: {
        slidesPerView: 3,
      },
    },
  });
}
